import React from "react";

import { Card, Icon } from "components";

const Step = ({ active, completed, rejected, dataTestId, position, text, onClick }) => {
  if (rejected)
    return (
      <Card dataTestId={dataTestId} className="onboarding-progress-card rejected-step active-step margin-bottom-100" onClick={onClick}>
        <div className="active-step-container">
          <div className="active-text-and-icon">
            <Icon data-testid={`${dataTestId}-rejected-icon`} className="general-icon rejected-icon" iconName="tabler/circle-x" />
            {text}
          </div>
          <div className="chevron-icon-right">
            <Icon data-testid={`${dataTestId}-rejected-icon`} iconName="tabler/chevron-right" />
          </div>
        </div>
      </Card>
    );

  if (active)
    return (
      <Card dataTestId={dataTestId} className="onboarding-progress-card active-step hover margin-bottom-100" onClick={onClick}>
        <div className="active-step-container">
          <div className="active-text-and-icon">
            <div data-testid={`${dataTestId}-active-icon`} className="general-icon active-icon ">
              {position}
            </div>
            {text}
          </div>
          <div className="chevron-icon-right">
            <Icon data-testid={`${dataTestId}-active-icon`} iconName="tabler/chevron-right" />
          </div>
        </div>
      </Card>
    );

  if (completed)
    return (
      <Card dataTestId={dataTestId} className="onboarding-progress-card completed-step margin-bottom-100">
        <Icon data-testid={`${dataTestId}-completed-icon`} className="general-icon completed-icon" iconName="tabler/circle-check" />
        {text}
      </Card>
    );

  if (active === false && completed === false)
    return (
      <Card dataTestId={dataTestId} className="onboarding-progress-card upcoming-step margin-bottom-100">
        <div data-testid={`${dataTestId}-upcoming-icon`} className="general-icon upcoming-icon">
          {position}
        </div>
        {text}
      </Card>
    );

  if (active === undefined || completed === undefined) {
    return null;
  }
};

export const ProgressSteps = ({ className, steps }) => (
  <div className={className}>
    {steps.map((step, i) => (
      <Step {...step} key={i} position={i + 1} />
    ))}
  </div>
);
